import * as contentful from 'contentful';

export const createClient = (mode?: 'delivery' | 'preview') => {
  const defaultMode = process.env.APP_ENV === 'development' ? 'preview' : 'delivery';
  const apiAccess = {
    delivery: {
      accessToken: process.env.CONTENTFUL_DELIVERY_ACCESS_TOKEN ?? '',
      host: process.env.CONTENTFUL_DELIVERY_HOST ?? '',
    },
    preview: {
      accessToken: process.env.CONTENTFUL_PREVIEW_ACCESS_TOKEN ?? '',
      host: process.env.CONTENTFUL_PREVIEW_HOST ?? '',
    },
  };
  const createClientParams: contentful.CreateClientParams = {
    space: process.env.CONTENTFUL_SPACE_ID ?? '',
    environment: process.env.CONTENTFUL_ENVIRONMENT ?? 'staging',
    ...apiAccess[mode ?? defaultMode],
  };

  return contentful.createClient(createClientParams);
};
